export default "__VITE_ASSET__DQCw2xJN__"